import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, SimpleChanges, inject } from '@angular/core';
import { IProductDataV3 } from '@df/catalog/product/product';
import { App } from '@df/core/app';
import { Client } from '@df/core/service/client';
import { PriceComponent } from '@df/ui/price/price.component';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { LocalProduct } from '../../../../model/product/product.decorator';
@Component({
    selector: 'product-price-trade',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [PriceComponent, CommonModule, TranslationModule],
    templateUrl: './product-price-trade.html'
})
export class ProductPriceTradeComponent {
    protected newPrice: number | undefined = undefined;
    protected app = inject(App);
    protected client = inject(Client);
    protected changeDetectorRef = inject(ChangeDetectorRef);

    @Input()
    product: LocalProduct<IProductDataV3>;

    @Input()
    variant: 'pdp' | 'plp' = 'pdp';

    ngOnInit(): void {
        this.app.customer.model.load().then(() => {
            this.newPrice = this.product?.tradeSalePrice;
            this.changeDetectorRef.detectChanges();
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['product'] && this.product) {
            this.newPrice = this.product?.tradeSalePrice;
            this.changeDetectorRef.detectChanges();
        }
    }
}
